import { init } from '../horizontal-scroller-init';

function go() {
  document.querySelectorAll('.horizontal-scroller').forEach(init);
}

// This script is loaded async so we need to check whether the DOM content is already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  go();
} else {
  window.addEventListener('DOMContentLoaded', go);
}
